'use client';

import {useRouter, useParams} from 'next/navigation';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import {ArchiveOutlined, ChatOutlined, DocumentScannerOutlined, PhoneForwardedOutlined} from "@mui/icons-material";
import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined';
import {navMap} from '../../../nav/navMap';
import {useTranslation} from 'react-i18next';
import {useCaseChats} from '../context/CaseChatsContext';
import {toast} from 'react-toastify';

export default function CaseMenuSpeedDial() {
    const router = useRouter();
    const params = useParams();
    const {t, i18n} = useTranslation("common");
    const currentLocale = i18n.language;
    const {isChatMessageResponsePending} = useCaseChats();

    const actions = [
        {icon: <ChatOutlined />, name: t('case-menu.chat.title'), redirectLink: 'chat'},
        {icon: <PhoneForwardedOutlined />, name: t('case-menu.summary.title'), redirectLink: 'summary'},
        {icon: <DocumentScannerOutlined />, name: t('case-menu.documents.title'), redirectLink: 'documents', addLink: 'base'},
        {icon: <ArchiveOutlined />, name: t('case-menu.repository.title'), redirectLink: 'repo'},
    ];

    const navToLink = (link: string, addLink?: string) => () => {
        if (params?.caseId && !isChatMessageResponsePending) {
            if (addLink) {router.push(navMap.locale(currentLocale).caseId(params.caseId.toString())[link]()[addLink]());}
            else {router.push(navMap.locale(currentLocale).caseId(params.caseId.toString())[link]());}
        } else {
            toast.error(t('chat.response-pending-redirect'));
        }
    };

    return (
        <>
            {params?.caseId &&
                <Box sx={{height: '380px', width: '80px', position: 'fixed', bottom: 0, right: 0}}>
                    <SpeedDial
                        direction='up'
                        ariaLabel="SpeedDial openIcon example"
                        sx={{position: 'absolute', bottom: 16, right: 16}}
                        icon={<SpeedDialIcon openIcon={<WidgetsOutlined />} />}
                    >
                        {actions.map((action) => (
                            <SpeedDialAction
                                key={action.name}
                                icon={action.icon}
                                tooltipTitle={action.name}
                                onClick={() => navToLink(action.redirectLink, action.addLink)()}
                            />
                        ))}
                    </SpeedDial>
                </Box>
            }
        </>
    );
}